import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOrganization } from ".";

export function useDeleteOrganization() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: deleteOrganization,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.organisation._def,
                exact: false,
            });
        }
    });
}
